export const CampaignUserList = [
  'msahu@automotivemastermind.com',
  'gbhatnagar@automotivemastermind.com',
  'nhadge@automotivemastermind.com',
  'avelez@automotivemastermind.com',
  'jpatel@automotivemastermind.com',
];
